import { ConfigProvider } from "antd";
// import "antd/dist/antd.css";
import esES from "antd/lib/locale/es_ES";
import React from "react";
import ReactDOM from "react-dom/client";
import { HashRouter } from "react-router-dom";
import { SWRConfig } from "swr";
import App from "./App";
import { fetcher } from "./config/swr";
import AuthProvider from "./context/authContext";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    // <React.StrictMode>

    <HashRouter>
        <ConfigProvider locale={esES}  theme={{
                token: {
                    // Seed Token
                    colorPrimary: '#244384',
                    fontFamily:"Montserrat, sans serif"
                },
                components: {
                    Layout: {
                        backgroundColor: '#f0f2f5',
                        algorithm: true, // Enable algorithm
                    }
                }
            }}
        >
            <AuthProvider>
                <SWRConfig
                    value={{
                        fetcher,
                        revalidateOnFocus: false,
                        revalidateIfStale: false,
                    }}
                >
                    <App />
                </SWRConfig>
            </AuthProvider>
        </ConfigProvider>
    </HashRouter>
    // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
